import statusActionTypes from "../actions/statusActionTypes";

export function statusReducer(state = {}, action) {
  switch (action.type) {
    case statusActionTypes.STATUS_FETCH_PENDING:
      return {
        ...state,
        isError: false,
        isPending: true,
      };
    case statusActionTypes.STATUS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        isError: false,
        isPending: false,
      };
    case statusActionTypes.STATUS_FETCH_ERROR:
      return {
        ...state,
        data: { respTime: "Unreachable" },
        isError: true,
        isPending: false,
      };
    default:
      return state;
  }
}
